import { createContext } from 'react'
// import { sessionStore } from '@/utils/storage'
// const paperData: any = sessionStore.get<any[]>('stepData', [])
export type TemporaryState = Record<string, any>
export interface TemporaryAction {
  type: 'SET_TEM_DATA' | 'SET_CATALOG_DATA'
  payload: any
}

export const TemporaryContext = createContext<TemporaryState | null>(null)

export const initTemporaryState: TemporaryState = {
  activeParagraph: -1,
  activeTextArea: -1
  // catalogList: paperData?.steps?.[3]?.catalogList || []
}

export const temporaryReducer = (state: TemporaryState, action: TemporaryAction): TemporaryState => {
  switch (action.type) {
    case 'SET_TEM_DATA':
      return { ...state, ...action.payload }
    // case 'SET_CATALOG_DATA':
    //   return { ...state, ...action.payload }
    default:
      return state
  }
}
